const infoField = { // 搜索字段配置
  // 充值记录    1
  "orderNo": "流水号：",
  "merchantName": "商户名称：",
  "agentName": "代理商名称：",
  "serviceFullName": "服务商名称：",
  "bankAccountName": "账户名称：",
  "startCreateTime": "申请时间（起）：",
  "endCreateTime": "申请时间（止）：",
  "startCheckedTime": "操作完成时间（起）：",
  "endCheckedTime": "操作完成时间（止）：",
  "auditFlag": "审核状态：",
  "accountType": "账户类型：",

  // 申请记录    2
  "startDate": "申请时间（起）：",
  "endDate": "申请时间（止）：",
  "taskName": "任务名称：",
  "taskNo": "任务编号：",
  "createUserName": "操作员账号名称：",

  // 支付明细    3 / 电子回单    4
  "detailNo": "明细单号：",
  "startAskTime": "操作完成时间（起）：",
  "endAskTime": "操作完成时间（止）：",
  "payUserName": "姓名：",
  "payUserCardNo": "身份证号：",
  "payUserMobile": "手机号：",
  "payStatus": "支付状态：",
  "paymentChannel": "支付通道：",
  "payOfBankType": "收款账户类型：",
  "isTransfer": "是否自动分流：",
  "receiptType": "电子回单状态：",

  // 任务承接记录    5
  "itemNumber": "任务编号：",
  "startTime": "发布时间（起）：",
  "endTime": "发布时间（止）：",
  "orderNumber": "商户名称：",
  "projectName": "任务名称：",
  "taskStatus": "任务状态：",
  "reviewStatus": "复核状态：",

  // 任务承接记录查看个人承接  -5
  "taskEmployeeName": "姓名：",
  "taskEmployeePhone": "手机号：",

  // 挂起订单    6
  "serviceName": "服务商名称：",

  // 验收文件    7
  "phaseNo": "验收文件编号：",
  "phaseStatus": "审核状态：",

  // 商户信息    8
  "name": "商户名称：",
  "businessName": "客户经理：",
  "id": "商户编号：",
  "loginID": "登录账号：",

  // 账户及余额  9
  "merchantId": "商户编号：",
  "accountNo": "账户编号：",

  // 查看明细    10
  "startUpdateTime": "操作时间（起）：",
  "endUpdateTime": "操作时间（止）：",
  "balanceSubject": "支付类型：",

  // 关联代理商  11 关联服务商  12
  "customRelation": "关联状态：",

  // 代理商信息  13

  // 个人认证    14
  "registerMobile": "手机号：",
  "cardCode": "身份证号：",
  "sourceType": "来源：",
  "auditFlagType": "认证状态：",
  "eSignStatusArray": "签署状态：",
  "preOrderWithAuth": "微信授权：",
  "fileSource": "协议来源：",

  // 个体户信息  15

  // 商务合作    16
  "mobile": "手机号：",
  "type": "入驻类型：",
  "isContact": "接待状态：",

  // 开票记录    17
  "billNo": "发票流水号：",

  // 开票类目管理    18
  "paraValue1": "开票类目：",

  // 未开票数据  19
  "billType": "查询方式：",

  // 个税申报    20
  "isSeason": "月度/季度：",
  "merchantFullName": "商户名称：",
  "taxMonth": "个税月份：",
  "asumMoney": "总营业额（起）：",
  "zsumMoney": "总营业额（止）：",
  "isNotTax": "有无个税：",
  "start": "申报状态：",

  // 税单查询    21

  // 月结分润    22
  "settleNo": "结算单号：",
  "startSettleTime": "分润时间（起）：",
  "endSettleTime": "分润时间（止）：",

  // 季结分润    23

  // 提现记录    24
  "cashOutNo": "订单号：",

  // 注销记录    25
  "destroyNo": "注销回执单号：",
  "status": "审核状态：",

  // 退款记录    26
  "refundStatus": "退款状态：",

  // 代理商财务管理  27

  // 代理商财务管理-交易流水  42

  // 商户对账单  28
  "oderByType": "排序：",
  "reconciliationNo": "对账单编号：",
  "amountType": "有效数据：",

  // 自动对账    29
  "partnerOrderNo": "第三方流水号：",
  "localStatus": "系统订单状态：",
  "channel": "支付方式：",
  "billResult": "比对结果：",
  "checked": "操作结果：",
  "localCreateTimeStart": "平台创建时间（起）：",
  "localCreateTimeEnd": "平台创建时间（止）：",
  "partnerTradeTimeStart": "第三方创建时间（起）：",
  "partnerTradeTimeEnd": "第三方创建时间（止）：",
  "createTimeStart": "数据比对时间（起）：",
  "createTimeEnd": "数据比对时间（止）：",
  "updateTimeStart": "操作时间（起）：",
  "updateTimeEnd": "操作时间（止）：",

  // 交易订单    30

  // 支付流水    31  电子回单下载   41
  "payBankAccount": "收款账号：",

  // 任务列表    32
  "taskPrincipal": "负责人：",

  // 用户管理    33
  "inviteType": "邀请类型：",
  "phone": "认证手机号：",

  // 费用明细    34
  "serviceId": "服务商id：",
  "balanceType": "收支状态：",

  // 充值记录    35

  // 退款记录    36
  "refundNo": "退款流水号：",
  "refundStatusStr": "退款状态：",
  "paymentStatusArr": "支付状态：",
  "refundType": "退款方式：",
  "checkUserName": "审核人员：",
  "hasInvoiced": "是否包含作废开票：",
  "hasPremium": "是否包含退款手续费：",
  "hasService": "请选择是否包含服务费：",
  "hasRefundFile": "请选择是否包含退款凭证：",
  "startCheckTime": "审核时间（起）：",
  "endCheckTime": "审核时间（止）：",
  // 到账啦推送记录 88
  "pushStatus": "推送状态：",
  "startPushTime": "推送时间（起）：",
  "endPushTime": "推送时间（起）：",


  // 商户对账单  37

  // 发票明细    38

  // 发票申请    39

  // 收件人管理  40

  // 重新支付    48
  "paymentOrderNo": "订单号：",

  // 支付宝记账本  49
  "agentFullName": "代理商：",
  "authorizeFullName": "授权账户：",
  "isvName": "ISV名称：",
  "authorizeStatus": "类型：",
  "validFlag": "操作：",

  // 未开票数据明细  75

  // 分页
  "pageNo": "起始页：",
  "pageSize": "条数：",
}

const sourceTypeObj = {
  "1": "小程序",
  "2": "API",
  "3": "E签宝-人脸",
  "4": "E签宝-短信",
  "5": "认证不限制",
}

const auditFlagTypeObj = {
  "0": "审核中",
  "1": "已认证",
  "2": "已驳回",
}

const eSignStatusObj = {
  "0": "待认证",
  "1": "待签署",
  "2": "已签署",
  "3": "已撤销",
  "4": "已过期",
}

const amountTypeObj = {
  "recharge": "充值总额",
  "grant": "发放总额",
  "service": "服务费总额",
}

const accountTypeObj = {
  2: "系统账户",
  5: "支付宝账户",
  9: "汇付宝账户",
  10: "民生账户",
}

const checkedObj = {
  0: "未操作",
  1: "一致",
  2: "不一致",
}

export default {
  infoField,
  sourceTypeObj,
  auditFlagTypeObj,
  eSignStatusObj,
  amountTypeObj,
  accountTypeObj,
  checkedObj
}



// WEBPACK FOOTER //
// ./src/utils/searchjson.js